import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Ellipse, Path } from "react-native-svg";

export const IconMedicinePill2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMedicinePill2"><Path d="M5.5 5.5L18.5 12" stroke="currentColor"/><Ellipse cx="11.5" cy="9" rx="10" ry="4.5" stroke="currentColor"/><Path d="M1.5 9V15C1.5 17.4853 5.97715 19.5 11.5 19.5C17.0228 19.5 21.5 17.4853 21.5 15V9" stroke="currentColor"/></CentralIconBase>;
});

export default IconMedicinePill2;
